export const PAYMENT_STATUS_ERROR = 'Error'
export const PAYMENT_STATUS_PROCESSED = 'Processed'

export const REASON_AUTO_RENEWAL = 'Auto renew - user confusion'
export const REASON_CHARGEBACK = 'Chargeback - Refund'
export const REASON_FRAUD = 'Fraud'
export const REASON_UNAUTHORIZED = 'Unauthorized Account Setup'
export const REASON_CANCEL_FAILED = 'Cancel Process Failed - Rebilled by error'
export const REASON_ACCIDENTAL_SIGNUP = 'Same day sign up/Accidental sign-up'
export const REASON_CHOSE_WRONG_SUBSCRIPTION = 'Wrong subscription chosen'
export const REASON_DUPLICATE_SUBSCRIPTION = 'Duplicate subscription'
export const REASON_HARDSHIP = 'Hardship'
export const REASON_NO_INTERNET = 'No internet'
export const REASON_EMAIL_TYPO = 'Email typo on account'
export const REASON_ACCIDENTAL_HOLD = 'Accidental hold instead of cancel'
export const REASON_CANCEL_OFFER_CONFUSION = 'Accepted cancel save offer - user confusion'
export const REASON_PLAN_CONFUSION = 'Plan confusion'
export const REASON_USER_MISTAKE = 'User mistake'
export const REASON_TOO_EXPENSIVE = 'Too expensive'
export const REASON_GIFT_CARD = 'Gift Card'
export const REASON_BILL_DATE_ADJUSTMENT = 'Bill Date Adjustment'
export const REASON_OTHER = 'Other'
export const REASON_GAIA_REFERRAL_REWARD = 'Gaia Referral Reward'
